// extracted by mini-css-extract-plugin
module.exports = {"root":"_1eOe9AStOwAIvf6Z7m6fXP","badge":"_2EwSgvQDoJb7DdSRb0uW07"};